module.exports = __webpack_public_path__ + "img/Apachelogo.7b24ca9b.png";